/* eslint-disable @typescript-eslint/no-unsafe-assignment -- Required because FlexProps allows arbitrary object spreading for component flexibility */
import React, { type ReactElement, type ComponentType } from 'react';
import Flex from '@alexanderjeurissen/flex';

type FlexProps = React.ComponentProps<typeof Flex>;

type Slot = ReactElement | ComponentType<Record<string, unknown>>;

interface TwoColumnProps {
  left: Slot;
  right: Slot;
  leftProps?: FlexProps;
  rightProps?: FlexProps;
  gap?: string;
  style?: React.CSSProperties;
  align?: FlexProps['align'];
  justify?: FlexProps['justify'];
}

const renderSlot = (slot: Slot): React.ReactNode => {
  if (React.isValidElement(slot)) return slot;
  if (typeof slot === "function") return React.createElement(slot);
  return null;
};

// Type-safe empty FlexProps for defaults
const EMPTY_FLEX_PROPS: FlexProps = {};

const TwoColumn: React.FC<TwoColumnProps> = ({
  left,
  right,
  leftProps,
  rightProps,
  gap = "2rem",
  style,
  align = "stretch",
  justify = "flex-start",
}) => (
  <Flex direction="row" align={align} justify={justify} gap={gap} style={style}>
    <Flex style={{ width: "50%" }} {...(leftProps ?? EMPTY_FLEX_PROPS)}>
      {renderSlot(left)}
    </Flex>
    <Flex style={{ width: "50%" }} {...(rightProps ?? EMPTY_FLEX_PROPS)}>
      {renderSlot(right)}
    </Flex>
  </Flex>
);

export default TwoColumn;
